/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles
import typography from "../../base/typography";
import borders from "../../base/borders";
import colors from "../../base/colors";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "../../functions/pxToRem";

const { size, fontWeightMedium } = typography;
const { borderRadius } = borders;
const { dark, white, primary } = colors;

export default {
  styleOverrides: {
    root: {
      color: white.main,
      cursor: "pointer",
      backgroundColor: 'transparent',
      display: "flex",
      alignItems: "center",
      flexDirection: "row" as any,
      flex: "1 1 auto",
      textAlign: "center" as any,
      maxWidth: "unset !important",
      minWidth: "unset !important",
      minHeight: "unset !important",
      margin: 2,
      fontWeight: fontWeightMedium,
      textTransform: "none" as any,
      fontSize: size.sm,
      lineHeight: "inherit",
      padding: pxToRem(4),
      borderRadius: borderRadius.lg,

      "&:hover": {
        backgroundColor: white.main,
        opacity: 0.8,
        color: dark.main
      },

      "& .selected":{
        
        backgroundColor: primary.main,
        color: "white"
      },

      "& .material-icons, .material-icons-round": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },

      "& svg": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },

    },
    labelIcon: {
      paddingTop: pxToRem(4)
    },
  }
};
